module.exports = __webpack_public_path__ + "static/media/magento.4435fdaa.svg";